import React from 'react';
import { useReveal } from '../lib/useReveal';
import { CheckIcon } from '../lib/icons';
const TOMOS = [{
  emoji: '📘',
  title: 'Tomo 1',
  subtitle: 'Fundamentos de Biodescodificación',
  desc: 'El origen, la historia y los principios del método. Cómo funciona el vínculo entre emoción y biología. Los 5 principios bio que cambian tu mirada sobre la enfermedad para siempre.'
}, {
  emoji: '📗',
  title: 'Tomo 2',
  subtitle: 'El Mapa del Síntoma',
  desc: 'Los 7 sistemas del cuerpo y su emocionalidad. Cómo leer la lateralidad, la ubicación y el tiempo del síntoma. Tu diccionario de 80+ síntomas con lectura bio completa.'
}, {
  emoji: '📙',
  title: 'Tomo 3',
  subtitle: 'Transgeneracional y Árbol Bio',
  desc: 'El sistema completo de árbol genealógico bio. Los 5 tipos de lealtades familiares. Cómo detectar y liberar los patrones que se repiten generación tras generación.'
}, {
  emoji: '📕',
  title: 'Tomo 4',
  subtitle: 'Protocolos de Sesión',
  desc: 'El protocolo más completo de sesión bio en español. Paso a paso. Exactamente qué preguntar. Exactamente cómo conducir, integrar y cerrar cada sesión con seguridad.'
}, {
  emoji: '📓',
  title: 'Tomo 5',
  subtitle: 'Casos Clínicos Reales',
  desc: '20+ casos reales analizados con el método completo. Aprendé viendo cómo se aplica en situaciones reales. El tomo que te da confianza antes de tu primera sesión.'
}, {
  emoji: '📔',
  title: 'Tomo 6',
  subtitle: 'Tu Consultorio Holístico Profesional',
  desc: 'Cómo convertir tu práctica en un negocio real. Precios, clientes, redes sociales, sesión online y todo lo que necesitás para vivir de la bio.'
}];
const INCLUDES = ['Protocolos paso a paso', 'Guías de sesión', 'Técnicas detalladas', 'Integración práctica', 'Contexto argentino'];
export function SystemSection() {
  const [ref1, vis1] = useReveal();
  const [ref2, vis2] = useReveal();
  return <section className="bg-black py-12 md:py-16 px-5 sm:px-6 border-t border-white/5" data-id="element-259">
      <div className="container mx-auto max-w-4xl" data-id="element-260">
        <div ref={ref1} className={`reveal text-center mb-12 ${vis1 ? 'is-visible' : ''}`} data-id="element-261">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-4 leading-tight text-[#eab308]" data-id="element-262">
            🏆 MEGAPACK BIODESCODIFICACIÓN INTEGRAL
          </h2>
          <p className="text-xl md:text-2xl text-white font-bold mb-2" data-id="element-263">
            6 Tomos + 6 Bonos — Síntoma · Conflicto · Sanación
          </p>
          <p className="text-gray-400 text-lg" data-id="element-264">
            Más de 500 páginas — Todo resuelto.
          </p>
        </div>

        <div className="text-center mb-8" data-id="element-265">
          <h3 className="text-2xl font-serif font-bold text-white tracking-widest uppercase" data-id="element-266">
            🧬 6 TOMOS COMPLETOS
          </h3>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-267">
          {TOMOS.map((tomo, i) => {
          const [ref, vis] = useReveal();
          return <div key={i} ref={ref} className={`reveal bg-[#111111] border border-white/10 rounded-xl p-6 transition-all hover:border-[#eab308]/30 ${vis ? 'is-visible' : ''}`} style={{
            transitionDelay: `${i * 50}ms`
          }} data-id="element-268">
                <div className="flex items-start gap-4" data-id="element-269">
                  <span className="text-3xl" data-id="element-270">{tomo.emoji}</span>
                  <div data-id="element-271">
                    <h4 className="text-[#eab308] font-bold text-sm tracking-widest uppercase mb-1" data-id="element-272">
                      {tomo.title}
                    </h4>
                    <h5 className="text-white font-serif font-bold text-xl mb-2 leading-tight" data-id="element-273">
                      {tomo.subtitle}
                    </h5>
                    <p className="text-gray-400 text-sm leading-relaxed" data-id="element-274">
                      {tomo.desc}
                    </p>
                  </div>
                </div>
              </div>;
        })}
        </div>

        <div ref={ref2} className={`reveal bg-gradient-to-br from-[#eab308]/10 to-[#d4a017]/5 border border-[#eab308]/20 rounded-xl p-6 md:p-8 text-center ${vis2 ? 'is-visible' : ''}`} data-id="element-275">
          <p className="text-white font-bold text-lg mb-4" data-id="element-276">
            Cada tomo incluye:
          </p>
          <div className="flex flex-wrap justify-center gap-3 sm:gap-6" data-id="element-277">
            {INCLUDES.map((item, i) => <div key={i} className="flex items-center gap-2" data-id="element-278">
                <div className="bg-[#eab308]/20 p-0.5 rounded-full" data-id="element-279">
                  <CheckIcon className="w-3 h-3 text-[#eab308]" strokeWidth={3} data-id="element-280" />
                </div>
                <span className="text-gray-300 text-sm font-medium" data-id="element-281">
                  {item}
                </span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}